import logo from './logo.svg';
import './App.css';
import Carousel from './components/Carousel';

function App() {
  return (
    <div className="App">
      <section id="welcome">
        <h1>1 in 3 American adults have prediabetes</h1>
      </section>
      <nav>
        <ul>
          <li><a href="#basic-info">Basic Info</a></li>
          <li><a href="#lifestyle-changes">Lifestyle Changes</a></li>
        </ul>
      </nav>
      <section id="basic-info">
        <h2>Basic Info</h2>
        <div class="info">
          <div class="info-box">
            <h3>What is Prediabetes?</h3>
            <p>Prediabetes is a condition where your blood sugar levels are higher than normal but not yet high enough to be diagnosed as diabetes. Roughly 1 in 3 American adults have prediabetes and roughly 85% of those people are completely unaware. Having prediabetes greatly increases the chances of developing type 2 diabetes but an early diagnosis and treatment as well as some lifestyle changes can help delay or prevent type 2 diabetes. </p>
          </div>
          <div class="info-box">
            <h3>How do I know if I am prediabetic?</h3>
            <p>The only way to determine an official diagnosis is by going to the doctor and doing a blood test. However, because prediabetes doesn’t often have many recognizable symptoms the American Diabetes Association and Center for Disease Control and Prevention have developed an online risk assessment to help you determine if you might have prediabetes. You can take this assessment and determine your risk <a href="https://www.cdc.gov/diabetes/risktest/index.html" target="_blank">at this link</a>. </p>
          </div>
          <div class="info-box">
            <h3>What steps can I take to help reverse prediabetes?</h3>
            <p>Treating prediabetes is extremely important as it can prevent type 2 diabetes which is a serious, chronic health condition that can lead to severe health issues such as heart disease, stroke, and kidney failure. If you have been diagnosed with prediabetes, you should follow through with the treatment recommended by your doctor. Also consider joining a lifestyle change program and following some of the recommendations below.</p>
          </div>
        </div>
      </section>
      <section id="lifestyle-changes">
        <h2>Lifestyle Changes</h2>
        <h3>Nutrition</h3>
        <Carousel />
        <h3>Fitness</h3>
        <Carousel />
      </section>
    </div>
  );
}

export default App;
